<div class="flex items-center justify-between">
  <div class="flex items-center gap-1">
    <lib-health-history-item-icon iconType="patient-alert" [grayedOut]="isUnderDeletion()" />
    <h3 class="typo-h4-medium leading-none" [class.text-text-light]="isUnderDeletion()">{{ patientAlertsItem().description ?? '' }}</h3>
  </div>
  <div class="flex items-center gap-3">
    <lib-patient-alerts-date-indicator [patientAlert]="patientAlertsItem()" />
    @if (hasEditButton() && !isEaglesoftPms()) {
      <button
        (click)="onEditButtonClick()"
        [disabled]="isEditDisabled()"
        [libUiTooltip]="!editPatientAlertEnabled() ? editDisabledTooltip : undefined"
        tooltipPosition="bottom"
      >
        @if (isNotReady()) {
          <lib-health-history-item-provisional-status-icon
            [provisionalStatus]="provisionalStatus()"
            itemType="patient-alert"
          ></lib-health-history-item-provisional-status-icon>
        } @else {
          <svg-icon
            class="max-h-4 max-w-4"
            [ngClass]="isEditDisabled() ? 'text-text-light' : 'text-primary-blue'"
            key="px-16-edit"
          ></svg-icon>
        }
      </button>

      <ng-template #editDisabledTooltip>
        <div class="typo-h7-light max-w-[190px] whitespace-pre-wrap p-1">
          {{ 'patient_alerts_edit_disabled_tooltip' | translate }}
        </div>
      </ng-template>
    }
  </div>
</div>
<lib-text-with-show-more
  class="typo-h4-light font-light leading-5"
  [text]="patientAlertsItem().noteText ?? ''"
  [maxRows]="lineClampRows()"
  [ngClass]="isUnderDeletion() ? 'text-text-light' : 'text-text-secondary'"
></lib-text-with-show-more>
